import Button from "@app/components/move2Library/Button/Button"
import { Checkbox } from "@app/components/move2Library/Checkbox/Checkbox"
import Input from "@app/components/move2Library/Input/Input"
import { useGetStrings } from "@app/store/service/cmsService"
import { useEditUserTranspoderData } from "@app/store/service/connectorService"
import { getDateString } from "@app/utils/localeUtils"
import { Modal, useModal } from "@tecreation/funnel-components"
import { useCallback } from "react"
import { useForm } from "react-hook-form"
import "./MyParadiseTransponderEditModal.css"
export const MyParadiseTransponderEditModal = ({ onClose, refetch, currentTransponder, defaultTransponder }) => {
	const [saveUserEdit] = useEditUserTranspoderData()
	const {
		data: {
			placeholderFirstName,
			placeholderLastName,
			placeholderBirthday,
			buttonSave,
			errorInputMissingFirstName,
			errorInputMissingLastName,
			errorInputMissingBirthday,
		},
	} = useGetStrings(undefined, { defaultData: {} })

	const { firstName, lastName, isDefault, birthDate } = currentTransponder
	const { hideModal } = useModal()
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: "onTouched",
		defaultValues: {
			firstName: firstName ? firstName : "",
			lastName: lastName ? lastName : "",
			isDefault: isDefault ? isDefault : false,
			birthDate: birthDate ? getDateString(new Date(birthDate)) : "",
		},
	})
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const onSaveClick = useCallback(async () => {
		handleSubmit(async data => {
			let date = data.birthDate.split(".")
			data.birthDate = new Date(date[2], date[1], date[0])
			if (data.isDefault && JSON.stringify(defaultTransponder) != JSON.stringify(currentTransponder) && defaultTransponder) {
				let temp = { ...defaultTransponder }
				temp.isDefault = false
				saveUserEdit(temp).then(() => {
					refetch()
					hideModal()
				})
			} else {
				let result = await saveUserEdit({ ...currentTransponder, ...data })
				if (result) {
					refetch()
					hideModal()
				}
			}
		})()
	})
	return (
		<Modal className="editTransponderModal">
			<Modal.Closer onClick={onClose} />

			<Modal.Header>Account edit</Modal.Header>
			<Modal.Body>
				<Checkbox label="Haupttransponder" className="m-4" formRegister={register("isDefault")} errors={errors} />
				<Input
					type="text"
					className="m-4"
					label={placeholderFirstName}
					placeholder={firstName}
					formRegister={register("firstName", {
						required: {
							value: true,
							message: errorInputMissingFirstName,
						},
					})}
					errors={errors}
				/>
				<Input
					type="text"
					className="m-4"
					label={placeholderLastName}
					placeholder={lastName}
					formRegister={register("lastName", {
						required: {
							value: true,
							message: errorInputMissingLastName,
						},
					})}
					errors={errors}
				/>
				<Input
					type="text"
					className="m-4"
					label={placeholderBirthday}
					placeholder="DD.MM.YYYY"
					formRegister={register("birthDate", {
						required: {
							value: true,
							message: errorInputMissingBirthday,
						},
					})}
					errors={errors}
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onSaveClick} style="primary">
					{buttonSave}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
